import { useMemo } from 'react'

import { RecurringInvoiceEventType } from '@features/recurringInvoices/enums/recurringInvoiceEventType'
import type { RecurringInvoiceEvent } from '@features/recurringInvoices/types/recurringInvoiceEvent'

import { useRecurringInvoice } from '../../../../../contexts/recurringInvoiceContext'

const allValidEventsTypes = Object.values(RecurringInvoiceEventType)

// making sure we display only what we can actually support on FE
const isVisibleTimelineEvent = ({ eventType }: RecurringInvoiceEvent): boolean => {
  return allValidEventsTypes.includes(eventType)
}

export const useSupportedRecurringInvoiceEvents = () => {
  const { recurringInvoice, isLoading } = useRecurringInvoice()

  const supportedRecurringInvoiceEvents = useMemo(() => {
    const statusEvents = recurringInvoice?.status.events || []

    return statusEvents.filter(isVisibleTimelineEvent)
  }, [recurringInvoice?.status.events])

  return { supportedRecurringInvoiceEvents, isLoading }
}
